import { render, staticRenderFns } from "./ProjectsCard.vue?vue&type=template&id=45b3d792&"
import script from "./ProjectsCard.vue?vue&type=script&lang=js&"
export * from "./ProjectsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports